// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"82de4c67","680":"857cff67"}[chunkId] + ".chunk.js";
};